import './src/styles/global.css';
import React from 'react';
import { ChakraProvider } from "@chakra-ui/react"
import { loadStripe } from "@stripe/stripe-js";
import { SegmentWrapper } from './src/components/Segment';
import ErrorBoundary from './src/components/error-boudary';


export const stripePromise = loadStripe(process.env.GATSBY_STRIPE_KEY ?? 'pk_test_51IX5VaAeQuygYI7pG2e7CbTNa7MLnfukJ0IGTmHnIkfDv8PAA0F7QWHjNiZcL6OEzhYOJ3JX9m0QepT0vA8TBjis00oNLAMPJq');


export const wrapRootElement = ({ element }) => (
    <>
   
    <ErrorBoundary>
        <SegmentWrapper />
        {element}
    </ErrorBoundary>
    </>

);